type ShowModalFn = () => void

let showModal: ShowModalFn | null = null

export function registerMobileFloorMapUnavailableModal(
  show: ShowModalFn | null,
): void {
  showModal = show
}

export function showMobileFloorMapUnavailableModal(): void {
  showModal?.()
}
